import $ from 'jquery';
import { createApp } from 'vue';
import ProductCrossSell from '../../../../assets/vue/components/ProductCrossSell/ProductCrossSell.vue';

const popup = $('.AddedToCartPopup');
let crossSellApp = null;
let crossSellRoot = null;

$(window).on('load', () => {
    popup.addClass('ready');
});

const showPopup = () => {
    popup.addClass('open');
    document.documentElement.style.overflowY = 'hidden';
};
const hidePopup = () => {
    popup.removeClass('open');
    document.documentElement.style.overflowY = 'auto';
};

$('.AddedToCartPopup').on('click', hidePopup);

$('.AddedToCartPopup__inner').on('click', function (ev) {
    ev.preventDefault();
    ev.stopImmediatePropagation();
});

function onSuccess(loadingCallback) {
    if (loadingCallback) {
        loadingCallback();
    }
    hidePopup();
    document.dispatchEvent(new CustomEvent('ovalia:open-cart'));
}

const refreshCartFragments = () => {
    $(document.body).trigger('updated_cart_totals');
    $(document.body).trigger('wc_fragment_refresh');
};

const addProductsToCart = (products) =>
    $.ajax({
        type: 'POST',
        url: jsData.ajaxUrl,
        data: {
            action: 'verenza_cross_sell_atc',
            products: JSON.stringify(products),
        },
        success: refreshCartFragments,
    });

const getProductCrossSells = () => {
    $.ajax({
        type: 'GET',
        url: jsData.ajaxUrl,
        data: {
            action: 'verenza_get_cross_sells_for_category',
        },
        success: (response) => {
            if (response.success) {
                if (!response.data.products.length) {
                    document.dispatchEvent(new CustomEvent('ovalia:open-cart'));
                } else {
                    if (crossSellApp) {
                        crossSellApp.unmount();
                        crossSellApp = null;
                        crossSellRoot = null;
                    }
                    crossSellApp = createApp(ProductCrossSell, {
                        products: response.data.products,
                        sections: response.data.sections || [],
                        rule: response.data.rule || null,
                        sourceProduct: response.data.source_product || null,
                        freeShipping: response.data.free_shipping || null,
                        addProductsToCart,
                        processToCart: onSuccess,
                        closePopup: hidePopup,
                    });
                    crossSellRoot = crossSellApp.mount('#app-popup-cross-sell');
                    showPopup();
                }
            }
        },
    });
};

$(document.body).on('added_to_cart', getProductCrossSells);

$('.AddedToCartPopup__continue').on('click', hidePopup);
